import { Injectable } from '@angular/core';
import { LegHelperService } from './leg-helper.service';
import {
  manuallyUpdateFormControlValidity,
  scheduleLegAttributeChange
} from '../utilities/leg.utilities';
import { FormGroup } from '@angular/forms';
import { Leg } from '@approot/models';

@Injectable({
  providedIn: 'root'
})
export class LegStrikeListenersService {
  constructor(private legHelperService: LegHelperService) {}

  public strikeListeners(): void {
    const form = this.legHelperService.form;
    const leg = this.legHelperService.leg;
    ['', '1', '2'].forEach(strikeNumber =>
      this.genericStrikeListener(strikeNumber, form, leg)
    );

    [
      'secondStrike',
      'strikeLong',
      'strikeShort',
      'strikeInRange',
      'callStrike',
      'putStrike',
      'basketStrike',
      'nearStrike'
    ].forEach(key => {
      this.legHelperService.subSink.sink = form
        .get(key)
        ?.valueChanges.subscribe(_ => {
          scheduleLegAttributeChange(form, leg, key, 'schedule');
        });
    });
  }

  private genericStrikeListener(
    strikeNumber: string,
    form: FormGroup,
    leg: Leg
  ): void {
    this.legHelperService.subSink.sink = form
      .get('strike' + strikeNumber)
      ?.valueChanges.subscribe(val => {
        if (val === '') {
          // if no strike wipe notional currency
          if (form.get('counterNotional' + strikeNumber)) {
            form
              .get('counterNotional' + strikeNumber)
              .setValue('', { emitEvent: false });
          }
        }
        manuallyUpdateFormControlValidity(
          'counterNotional' + strikeNumber,
          form
        );
        scheduleLegAttributeChange(
          form,
          leg,
          'strike' + strikeNumber,
          'schedule'
        );
      });
  }
}
